
<section class="section">
    <div class="section-header">
      <h2>Therapeutic Area</h2>
      <p>Select the relevant therapeutic area</p>
    </div>
    
    <div class="therapeutic-grid">
      <div 
        *ngFor="let area of therapeuticAreas" 
        class="therapeutic-card"
        [class.selected]="isAreaSelected(area)"
        (click)="toggleAreaSelection(area)">
        <span>{{ area }}</span>
        <div class="checkbox-indicator">
          <i class="fas fa-check" *ngIf="isAreaSelected(area)"></i>
        </div>
      </div>
    </div>

    <!-- Proceed button for multiple selection -->
    <div class="proceed-section">
      <button 
        class="btn btn-primary proceed-btn" 
        [disabled]="!canProceed"
        (click)="proceedWithSelection()">
        <i class="fas fa-arrow-right"></i>
        Proceed with {{ selectedAreas.length }} selected therapeutic areas
      </button>
    </div>
  </section>
  